<template>
  <prompt-manager
    title="Prompts (Tout AIF)"
    :prefixes="['AIF']"
    default-new-template-prefix="AIF "
  />
</template>

<script>
import PromptManager from "@/components/llpr/PromptManager.vue";

export default {
  name: "AiFactoryPromptConfig",
  components: {
    PromptManager,
  },
};
</script>
